// extracted by mini-css-extract-plugin
module.exports = {"header":"UKDrawer_header__D35L5","headerText":"UKDrawer_headerText__qnbrD","headerButton":"UKDrawer_headerButton__J9J81"};